import React from 'react';

import styled from 'styled-components';

import InputMultipleEmails from 'components/lib/InputMultipleEmails';
import TextArea from 'components/lib/TextArea';

import { useShareViaEmailContext } from '../ShareViaEmailContext';
import ShareViaEmailExistingUsers from '../ShareViaEmailExistingUsers';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 670px;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 30px;
  padding-bottom: 10px;
`;

const Title = styled.h1`
  font-size: 20px;
`;

const Label = styled.h1`
  font-size: 14px;
  color: #222;
  margin-top: 27px;
  margin-bottom: 5px;
`;

const Paragraph = styled.p`
  font-size: 12px;
  color: var(--gray-dark);
`;

const ShareViaEmailMainContent = () => {
  const { shareTabData, users, updateShareTabData, handleUserSearch } = useShareViaEmailContext();
  const selectedUsers = shareTabData.selectedUsers ?? [];

  return (
    <Container>
      <Content>
        <Title>Share via Email</Title>
        <Paragraph>
          The view with its saved filters will be sent via email as a clickable link, to the people below.
        </Paragraph>
        <Label>New Email Addresses</Label>
        <InputMultipleEmails
          emails={shareTabData.emails}
          setEmails={(newEmails: string[]) => updateShareTabData({ emails: newEmails })}
        />
        <ShareViaEmailExistingUsers
          users={users}
          selectedUsers={selectedUsers}
          onSelect={(user) => updateShareTabData({ selectedUsers: [...selectedUsers, user] })}
          onDeselect={(user) => updateShareTabData({ selectedUsers: selectedUsers.filter((u) => u.id !== user.id) })}
          onSelectAll={() =>
            updateShareTabData({
              selectedUsers: selectedUsers.length === users.length ? [] : [...users],
            })
          }
          onSearch={handleUserSearch}
        />
        <Label>Note (optional)</Label>
        <TextArea
          value={shareTabData.note}
          onChange={(e: any) => updateShareTabData({ note: e.target.value })}
          placeholder="Add an optional note here to display in the email"
          rows={4}
        />
      </Content>
    </Container>
  );
};

export default ShareViaEmailMainContent;
